<template>
  <div class="box">
    <div class="row">
      <div class="col-lg-8 box-img-wrapper">
        <ImageWrapper :file="idea.idFile"></ImageWrapper>
      </div>
      <div class="col-lg-4 box-inner">
        <span class="box-big-tag"><i class="icon-fav-empty"></i> {{ idea.featured }}</span>
        <span v-if="idea" class="box-tag">
          <span>{{ idea._embedded.Category.value }}</span>
          <span>{{ idea._embedded.Content.createdAt | formatDate2 }}</span>
        </span>
        <router-link v-if="idea" class="box-title" :to="{name: 'IdeaOverview', params: {id: idea.idPost}}">
          <span>{{ idea.headline }}</span>
        </router-link>
        <div class="box-bottom">
          <span class="span-icon"><i class="icon-vote-empty"></i> {{ idea.votes }}</span>
          <span class="span-icon"><i class="icon-comment"></i> {{ idea.commentsCounter }}</span>
          <span class="span-icon" v-if="isOpenVoting(idea.votingDeadline)"><i class="icon-time"></i> {{idea.votingDeadline |daysToVote}}</span>
          <span class="span-icon" v-else><i class="icon-time"></i> Closed</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ImageWrapper from "@/components/general/ImageWrapper";
export default {
  name: 'IdeaHeroBox',
  components: {ImageWrapper},
  props: ['idea'],
  computed: {
  },
  methods: {
    isOpenVoting(date) {
      return Math.floor((new Date(date) - new Date(new Date().toUTCString().substr(0, 25))) / 1000) > 0
    },
    daysToVote(date) {
      let seconds = Math.floor((new Date(date) - new Date(new Date().toUTCString().substr(0, 25))) / 1000);
      let interval = seconds / 86400;
      return Math.floor(interval) + " days left";
    }
  }
}
</script>

<style scoped>

</style>
